import app from './index';

runBlock.$inject = ['$location', '$resource', '$window', 'localStorageService', '$q', '$http', '$translate'];

export default function runBlock($location, $resource, $window, localStorageService, $q, $http, $translate) {
  'ngInject';

  if ($location.$$host === 'localhost') {
    app.serviceBase = 'http://localhost:6001';
    //app.serviceBase = 'http://mvoss-api.azurewebsites.net';
  } else if ($location.$$host.indexOf('mvoss-test') >= 0) {
    app.serviceBase = 'http://mvoss-api-test.azurewebsites.net';
  } else {
    app.serviceBase = 'http://mvoss-api.azurewebsites.net';
  }

  app.artikel = [];
  app.kontakt = {};
  app.$location = $location;
  app.$window = $window;
  app.translate = $translate;
  app.authData = localStorageService.get('authorizationData');
  app.language = $translate.preferredLanguage();

  app.login = (username, password) => {
    let deferred = $q.defer();

    let req = {
      method: 'POST',
      url: app.serviceBase + "/token",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: "grant_type=password&username=" + username + "&password=" + password,
    };

    $http(req)
      .success((response) => {
        app.authData = {
          /*jshint camelcase: false */
          token: response.access_token,
          username: username
        };
        localStorageService.set('authorizationData', app.authData);
        window.toastr.info("Erfolgreich angemeldet");
        deferred.resolve(response);
      })
      .error(() => {
        app.logout();
        window.toastr.error("Fehler bei Anmeldung");
      });

    return deferred.promise;
  };

  app.logout = () => {
    localStorageService.remove('authorizationData');
    app.authData = null;
  };

  app.clearCard = () => {
    app.artikel = [];
  };

  app.addToCard = (artikel) => {
    if (artikel.menge) {
      app.artikel.push(artikel);
    }
  };

  app.isAuth = () => {
    return app.authData !== null;
  };

  app.api = {
    kontakte: $resource(app.serviceBase + '/kontakte'),
    artikelKategorien: $resource(app.serviceBase + '/artikelKategorien'),
    kunden: $resource(app.serviceBase + '/kunden', {
      id: '@Id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    }),
    artikel: $resource(app.serviceBase + '/artikel/:id', {
      id: '@Id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      },
      'lagerBestandAktualisieren': {
        method: 'PATCH',
        isArray: false,
        url: app.serviceBase + '/artikel/lager/aktualisieren'
      }
    }),
    anfragen: $resource(app.serviceBase + '/anfragen/:id', {
      id: '@Id'
    }, {
      'gelesen': {
        method: 'PATCH',
        isArray: false,
        url: app.serviceBase + '/anfragen/:id/gelesen'
      }
    }),
    rechnungen: $resource(app.serviceBase + '/rechnungen/:id', {
      id: '@Id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      },
      'stornieren': {
        method: 'PATCH',
        isArray: false,
        url: app.serviceBase + '/rechnungen/:id/stornieren'
      },
      'bezahlen': {
        method: 'PATCH',
        isArray: false,
        url: app.serviceBase + '/rechnungen/:id/bezahlen'
      },
      'aendern': {
        // Rechnung stornieren und neue Rechnung erzeugen
        method: 'GET',
        isArray: false,
        url: app.serviceBase + '/rechnungen/:id/aendern'
      }
    })
  };
}



/** WEBPACK FOOTER **
 ** ./public/app/index.run.js
 **/